import React, { useEffect, useState } from 'react';
import { simboloMoneda } from '../services/negocioActual';
import { obtenerAbono, editarAbono } from '../services/porCobrarService';
import { obtenerCuentas, iconoTipo } from '../services/cuentasService';
import { mensajeAmigable } from '../utils/errores';
import { aNumero } from '../utils/validacion';
import CampoNumero from './CampoNumero';
import { useToast } from '../context/ToastContext';

const fmt = (n) => `${simboloMoneda()} ${Number(n || 0).toLocaleString('es-HN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Corrige un abono (monto y/o cuenta) desde el Balance. El dinero se ajusta
// solo: vuelve a la cuenta vieja y entra a la nueva (reverso atómico).
export default function EditarAbonoModal({ referencia, onCerrar, onGuardado, onEditarVenta }) {
  const { mostrarToast } = useToast();
  const [form, setForm] = useState(null);
  const [cuentas, setCuentas] = useState([]);
  const [error, setError] = useState(null);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    Promise.all([obtenerAbono(referencia), obtenerCuentas()])
      .then(([a, cs]) => {
        setCuentas(cs);
        setForm({ monto: String(a.monto ?? ''), cuentaId: a.cuenta_id || (cs[0]?.id || ''), fecha: a.fecha || '' });
      })
      .catch((e) => setError(mensajeAmigable(e)));
  }, [referencia]);

  const guardar = async () => {
    if (!(aNumero(form.monto) > 0)) { mostrarToast('Escribe el monto del abono (solo números, mayor que 0)', 'error'); return; }
    setGuardando(true);
    try {
      await editarAbono(referencia, { monto: form.monto, cuentaId: form.cuentaId || null, fecha: form.fecha || null });
      mostrarToast('Abono corregido. Dinero ajustado ✅', 'exito');
      onGuardado?.();
      onCerrar();
    } catch (e) {
      const msg = (e?.message || '').includes('MONTO_MAYOR_AL_SALDO')
        ? 'El abono no puede ser mayor a lo que la clienta debe.'
        : mensajeAmigable(e);
      mostrarToast(msg, 'error');
    } finally {
      setGuardando(false);
    }
  };

  const input = { width: '100%', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' };
  const label = { fontSize: '12px', color: '#6B7280', fontWeight: 600, display: 'block', marginBottom: '4px' };

  return (
    <div onClick={onCerrar} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', zIndex: 1200 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: 'white', borderRadius: '16px', width: '100%', maxWidth: '420px', boxShadow: '0 10px 40px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #F3F4F6', backgroundColor: '#FEF3C7', borderRadius: '16px 16px 0 0' }}>
          <h3 style={{ margin: 0, color: '#B45309', fontSize: '18px' }}>✏️ Editar abono</h3>
          <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#92400E' }}>El dinero se ajusta solo en tus cuentas.</p>
        </div>
        <div style={{ padding: '20px' }}>
          {error && <p style={{ color: '#991B1B', fontWeight: 600 }}>⚠️ {error}</p>}
          {!form && !error && <p style={{ color: '#6B7280', textAlign: 'center', padding: '20px' }}>⏳ Cargando...</p>}
          {form && (
            <>
              <div style={{ marginBottom: '12px' }}>
                <label style={label}>Monto del abono (L) *</label>
                <CampoNumero valor={form.monto} onChange={(v) => setForm({ ...form, monto: v })} deshabilitado={guardando}
                  min={0} prefijo="L" placeholder="0.00" estilo={input} />
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label style={label}>Medio de pago / cuenta</label>
                <select value={form.cuentaId} disabled={guardando} onChange={(e) => setForm({ ...form, cuentaId: e.target.value })} style={input}>
                  {cuentas.length === 0 && <option value="">Sin cuentas</option>}
                  {cuentas.map((c) => <option key={c.id} value={c.id}>{iconoTipo(c.tipo)} {c.nombre}</option>)}
                </select>
              </div>
              <div style={{ marginBottom: '18px' }}>
                <label style={label}>Fecha del pago</label>
                <input type="date" value={form.fecha} disabled={guardando} onChange={(e) => setForm({ ...form, fecha: e.target.value })} style={input} />
              </div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <button onClick={onCerrar} disabled={guardando}
                  style={{ flex: '0 0 auto', padding: '12px 18px', background: 'white', border: '1px solid #D1D5DB', borderRadius: '10px', cursor: 'pointer', color: '#6B7280', fontWeight: 600 }}>Cancelar</button>
                <button onClick={guardar} disabled={guardando}
                  style={{ flex: 1, padding: '12px', backgroundColor: guardando ? '#9CA3AF' : '#B45309', color: 'white', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: 'bold', cursor: guardando ? 'wait' : 'pointer' }}>
                  {guardando ? '⏳ Guardando...' : `Guardar ${form.monto ? fmt(form.monto) : ''}`}
                </button>
              </div>
              {onEditarVenta && (
                <button onClick={onEditarVenta} disabled={guardando}
                  style={{ width: '100%', marginTop: '10px', padding: '10px', background: 'white', color: '#B45309', border: '1px solid #FCD34D', borderRadius: '10px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer' }}>
                  ✏️ Editar la venta completa (canal, envío, productos…)
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
